import { type InputHTMLAttributes, forwardRef } from 'react'
import styled from 'styled-components'

export interface BaseInputProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string
  type: string
}

const StyledInput = styled.input`
  border: none;
  outline: none;
  appearance: none;
  font-size: 16px;
  line-height: 21px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`

export const BaseInput = forwardRef<HTMLInputElement, BaseInputProps>((props, ref) => (
  <StyledInput ref={ref} {...props} />
))

BaseInput.displayName = 'BaseInput'
